import { type MedicalNoteType } from "types";

export const isKickOffNote = (label: MedicalNoteType): boolean => {
  return label.toUpperCase() === "PROTOCOL_WEEKLY_W0";
};

export const isChatNote = (label: MedicalNoteType): boolean => {
  return label.toUpperCase() === "CHAT";
};

export const isRTMNote = (label: MedicalNoteType): boolean => {
  return ["RTM_ADDITIONAL", "RTM_ADHERENCE", "RTM_FIRST", "RTM_INITIAL", "RTM_PARTIAL", "RTM_SHORT_ADHERENCE"].includes(
    label.toUpperCase()
  );
};

export const isRTMInitial = (label: MedicalNoteType): boolean => {
  return label.toUpperCase() === "RTM_INITIAL";
};
